import { Injectable, ModuleWithProviders, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class DadosServiceAbstract {
  constructor (public db: AngularFirestore/*, @Inject('configDados') public config*/) {
    this.init();
  }
  init() {
  }
}
